/**Dependencies */
import React from 'react'

/*Styles*/
import '../styles/loader.scss';

/*Images*/
import gif from '../images/loaders/loader.gif'

export const Loader = () => {
  return (
    <div className="loaderOverlay">
      <div className="loader d-flex justify-content-center">
        <img src={gif} alt="Cargando..." />
      </div>
    </div>
  )
}
